<template>
  <!-- 邀请好友赚查询次数页面（与安卓端同一套后端接口：user/invite_info、user/invite_records） -->
  <div class="invite-page-root">
    <!-- 顶部横幅 -->
    <div class="invite-hero">
      <h2 class="invite-hero-title">邀请好友 · 赚查询次数</h2>
      <p class="invite-hero-sub">分享你的专属邀请码，好友注册双方都得次数</p>
    </div>

    <!-- 奖励规则卡 -->
    <div class="invite-rules">
      <div class="rule-row">
        <span class="rule-ico">👤</span>
        <div class="rule-text">
          <b>邀请人（你）</b>
          <p>每邀请 1 位新用户注册</p>
        </div>
        <span class="rule-val">+{{ inviteInfo.reward_inviter }} 次查询</span>
      </div>
      <div class="rule-row">
        <span class="rule-ico">🎁</span>
        <div class="rule-text">
          <b>新用户</b>
          <p>凭你的邀请码注册</p>
        </div>
        <span class="rule-val">立得 {{ inviteInfo.reward_newuser }} 次查询</span>
      </div>
      <div class="rule-row">
        <span class="rule-ico">🔄</span>
        <div class="rule-text">
          <b>循环裂变</b>
          <p>好友也能生成自己的邀请码</p>
        </div>
        <span class="rule-val">奖励不限</span>
      </div>
    </div>

    <!-- 统计卡 -->
    <div class="invite-stats">
      <div class="stat-cell">
        <span class="stat-num">{{ inviteInfo.invited_count }}</span>
        <span class="stat-label">已邀请好友</span>
      </div>
      <div class="stat-divider"></div>
      <div class="stat-cell">
        <span class="stat-num">{{ inviteInfo.total_earned }}</span>
        <span class="stat-label">累计获得次数</span>
      </div>
    </div>

    <!-- 邀请码卡 -->
    <div class="invite-code-card">
      <p class="invite-code-label">我的邀请码</p>
      <div class="invite-code-value" @click="copyCode">{{ inviteInfo.invite_code || '······' }}</div>
      <div class="invite-actions">
        <Button type="primary" :loading="loading" @click="copyCode">复制邀请码</Button>
        <Button @click="copyLink">复制邀请链接</Button>
      </div>
      <div v-if="inviteInfo.qrcode" class="invite-qrcode">
        <img :src="inviteInfo.qrcode" alt="邀请二维码" />
      </div>
      <p v-if="inviteInfo.qrcode" class="invite-qrcode-tip">扫码注册 · 新用户立得 {{ inviteInfo.reward_newuser }} 次免费查询</p>
    </div>

    <!-- 邀请记录 -->
    <div class="invite-records">
      <h4 class="invite-records-title">邀请记录</h4>
      <div v-if="records.length === 0" class="invite-empty">
        暂无邀请记录，复制邀请码分享给好友吧
      </div>
      <div v-else class="record-row" v-for="(r, i) in records" :key="i">
        <span class="record-user">{{ r.username_masked }}</span>
        <span class="record-reward">+{{ r.reward }} 次</span>
        <span class="record-time">{{ r.created_at }}</span>
      </div>
    </div>
  </div>
</template>

<script>
// 引入封装好的 axios 实例（自动携带 Bearer token）
import apiClient from '../api/index.js';

export default {
  name: 'InviteFriends',
  data() {
    return {
      loading: false, // 复制按钮加载状态
      // 邀请主页数据（字段与安卓端 InviteScreen.kt 解析保持一致）
      inviteInfo: {
        invite_code: '',      // 我的邀请码
        invited_count: 0,     // 已邀请人数
        total_earned: 0,      // 累计获得次数
        reward_inviter: 5,    // 每邀请 1 人奖励次数（邀请人）
        reward_newuser: 1,    // 新用户注册奖励次数
        qrcode: ''            // 邀请二维码 dataUri（后端生成）
      },
      records: [] // 邀请记录列表
    };
  },
  mounted() {
    // 进入页面即拉取邀请信息与记录
    this.fetchInviteInfo();
    this.fetchRecords();
  },
  methods: {
    // 获取邀请主页信息：邀请码、统计、奖励配置、二维码
    async fetchInviteInfo() {
      try {
        const response = await apiClient.get('/user/invite_info');
        if (response.data.code === 200 && response.data.data) {
          const d = response.data.data;
          this.inviteInfo = {
            invite_code: d.invite_code || '',
            invited_count: d.invited_count || 0,
            total_earned: d.total_earned || 0,
            reward_inviter: d.reward_inviter || 5,
            reward_newuser: d.reward_newuser || 1,
            qrcode: d.qrcode || ''
          };
        }
      } catch (error) {
        console.error('获取邀请信息失败:', error);
      }
    },
    // 获取邀请记录列表（后端已做用户名脱敏）
    async fetchRecords() {
      try {
        const response = await apiClient.get('/user/invite_records');
        if (response.data.code === 200 && response.data.data) {
          this.records = response.data.data.list || [];
        }
      } catch (error) {
        console.error('获取邀请记录失败:', error);
      }
    },
    // 复制文本：优先 Clipboard API，失败降级 execCommand
    async copyText(text, tip) {
      if (!text) {
        this.$Message.warning('邀请码尚未生成，请稍后再试');
        return;
      }
      try {
        if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
          await navigator.clipboard.writeText(text);
          this.$Message.success(tip);
        } else {
          const textarea = document.createElement('textarea');
          textarea.value = text;
          textarea.style.position = 'fixed';
          textarea.style.opacity = '0';
          document.body.appendChild(textarea);
          textarea.select();
          const ok = document.execCommand('copy');
          document.body.removeChild(textarea);
          if (ok) {
            this.$Message.success(tip);
          } else {
            this.$Message.error('复制失败，请手动复制');
          }
        }
      } catch (error) {
        this.$Message.error('复制失败，请手动复制');
      }
    },
    // 复制邀请码
    copyCode() {
      this.copyText(this.inviteInfo.invite_code, '邀请码已复制：' + this.inviteInfo.invite_code);
    },
    // 复制邀请链接：注册页自动读取 ?invite_code= 并预填
    copyLink() {
      const link = window.location.origin + window.location.pathname + '?invite_code=' + (this.inviteInfo.invite_code || '');
      this.copyText(link, '邀请链接已复制，快去分享给好友吧');
    }
  }
};
</script>

<style scoped>
/* ==================== 邀请页（7 皮肤主题变量） ==================== */
.invite-page-root {
  --inv-accent: #2d8cf0;
  --inv-accent-soft: rgba(45, 140, 240, 0.1);
  --inv-card-bg: #ffffff;
  --inv-card-border: rgba(45, 140, 240, 0.16);
  --inv-text: #3d4a5c;
  --inv-sub: #7a8699;
  --inv-gold: #f5a623;
  max-width: 720px;
  margin: 0 auto;
  padding: 18px 16px 30px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* 顶部横幅：主题色渐变 */
.invite-hero {
  padding: 26px 20px;
  border-radius: 14px;
  text-align: center;
  color: #fff;
  background: linear-gradient(135deg, var(--inv-accent) 0%, var(--inv-accent-deep, #1554ad) 100%);
  box-shadow: 0 8px 24px var(--inv-accent-soft);
}

.invite-hero-title {
  margin: 0 0 8px;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 1px;
}

.invite-hero-sub {
  margin: 0;
  font-size: 13px;
  opacity: 0.9;
}

/* 奖励规则卡 */
.invite-rules {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 16px;
  border-radius: 14px;
  background: var(--inv-card-bg);
  border: 1px solid var(--inv-card-border);
}

.rule-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 4px;
}

.rule-row + .rule-row {
  border-top: 1px dashed var(--inv-card-border);
}

.rule-ico {
  font-size: 20px;
}

.rule-text {
  flex: 1;
}

.rule-text b {
  display: block;
  font-size: 14px;
  color: var(--inv-text);
}

.rule-text p {
  margin: 2px 0 0;
  font-size: 12px;
  color: var(--inv-sub);
}

.rule-val {
  font-size: 14px;
  font-weight: 700;
  color: var(--inv-gold);
  white-space: nowrap;
}

/* 统计卡 */
.invite-stats {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 40px;
  padding: 16px;
  border-radius: 14px;
  background: var(--inv-card-bg);
  border: 1px solid var(--inv-card-border);
}

.stat-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.stat-num {
  font-size: 26px;
  font-weight: 700;
  color: var(--inv-accent);
  font-family: Consolas, 'Courier New', monospace;
}

.stat-label {
  font-size: 12px;
  color: var(--inv-sub);
}

.stat-divider {
  width: 1px;
  height: 34px;
  background: var(--inv-card-border);
}

/* 邀请码卡 */
.invite-code-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 22px 16px;
  border-radius: 14px;
  background: var(--inv-card-bg);
  border: 1px solid var(--inv-card-border);
  text-align: center;
}

.invite-code-label {
  margin: 0;
  font-size: 13px;
  color: var(--inv-sub);
  letter-spacing: 2px;
}

/* 邀请码大字：等宽字体 + 主题色发光 */
.invite-code-value {
  font-family: Consolas, 'Courier New', monospace;
  font-size: 36px;
  font-weight: 700;
  letter-spacing: 6px;
  color: var(--inv-accent);
  text-shadow: 0 0 14px var(--inv-accent-soft);
  cursor: pointer;
  user-select: all;
}

.invite-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;
}

.invite-qrcode {
  padding: 10px;
  border-radius: 12px;
  background: #ffffff;
  border: 1px solid var(--inv-card-border);
}

.invite-qrcode img {
  display: block;
  width: 168px;
  height: 168px;
}

.invite-qrcode-tip {
  margin: 0;
  font-size: 12px;
  color: var(--inv-sub);
}

/* 邀请记录 */
.invite-records {
  padding: 14px 16px;
  border-radius: 14px;
  background: var(--inv-card-bg);
  border: 1px solid var(--inv-card-border);
}

.invite-records-title {
  margin: 0 0 8px;
  font-size: 15px;
  font-weight: 700;
  color: var(--inv-text);
}

.invite-empty {
  padding: 20px 0;
  text-align: center;
  font-size: 13px;
  color: var(--inv-sub);
}

.record-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 9px 4px;
  font-size: 13px;
}

.record-row + .record-row {
  border-top: 1px dashed var(--inv-card-border);
}

.record-user {
  flex: 1;
  color: var(--inv-text);
}

.record-reward {
  font-weight: 700;
  color: var(--inv-gold);
}

.record-time {
  color: var(--inv-sub);
  font-size: 12px;
}

/* ==================== 星空主题（深色玻璃） ==================== */
.theme-starry .invite-page-root {
  --inv-accent: #64ffda;
  --inv-accent-deep: #0e7a66;
  --inv-accent-soft: rgba(100, 255, 218, 0.15);
  --inv-card-bg: rgba(16, 28, 56, 0.6);
  --inv-card-border: rgba(100, 255, 218, 0.22);
  --inv-text: #d7e2f2;
  --inv-sub: #8a97ad;
  --inv-gold: #ffd54d;
}

/* ==================== 蓝/紫/绿/红/橙 皮肤：覆盖主题色 ==================== */
.theme-blue .invite-page-root {
  --inv-accent: #1976d2;
  --inv-accent-deep: #0d47a1;
  --inv-accent-soft: rgba(25, 118, 210, 0.12);
  --inv-card-border: rgba(25, 118, 210, 0.2);
}

.theme-purple .invite-page-root {
  --inv-accent: #7b1fa2;
  --inv-accent-deep: #4a148c;
  --inv-accent-soft: rgba(123, 31, 162, 0.12);
  --inv-card-border: rgba(123, 31, 162, 0.2);
}

.theme-green .invite-page-root {
  --inv-accent: #388e3c;
  --inv-accent-deep: #1b5e20;
  --inv-accent-soft: rgba(56, 142, 60, 0.12);
  --inv-card-border: rgba(56, 142, 60, 0.2);
}

.theme-red .invite-page-root {
  --inv-accent: #d32f2f;
  --inv-accent-deep: #8e0000;
  --inv-accent-soft: rgba(211, 47, 47, 0.12);
  --inv-card-border: rgba(211, 47, 47, 0.2);
}

.theme-orange .invite-page-root {
  --inv-accent: #f57c00;
  --inv-accent-deep: #b35309;
  --inv-accent-soft: rgba(245, 124, 0, 0.12);
  --inv-card-border: rgba(245, 124, 0, 0.2);
}

/* ==================== 移动端适配 ==================== */
@media (max-width: 768px) {
  .invite-page-root {
    padding: 12px 10px 24px;
    gap: 12px;
  }

  .invite-hero-title {
    font-size: 19px;
  }

  .invite-code-value {
    font-size: 28px;
    letter-spacing: 4px;
  }

  .invite-qrcode img {
    width: 140px;
    height: 140px;
  }

  .record-time {
    display: none;
  }
}
</style>
